import { render, staticRenderFns } from "./restFacilitiesFixturesPop.vue?vue&type=template&id=649b5a90"
import script from "./restFacilitiesFixturesPop.vue?vue&type=script&lang=js"
export * from "./restFacilitiesFixturesPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649b5a90')) {
      api.createRecord('649b5a90', component.options)
    } else {
      api.reload('649b5a90', component.options)
    }
    module.hot.accept("./restFacilitiesFixturesPop.vue?vue&type=template&id=649b5a90", function () {
      api.rerender('649b5a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rtf/restFacilitiesFixturesPop.vue"
export default component.exports